import React from 'react';
import styles from '../../common/utils/styles/css/styles';
import { Container, MaxWidth } from '../../common/base';
import styled, { css } from 'styled-components';

const Benefit = styled.div`
  flex: 1 1 50%;
  ${MaxWidth.sm`
    flex: 1 1 100%;
  `}
  padding: 10px 50px 10px 0;
  font-weight: bold;
  color: ${({ theme: { colors } }) => colors.dark.neutral};
  text-align: left;

  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 50px;
    height: 50px;
    margin-right: 20px;
  }
`;

export default function Benefits() {
  return (
    <div
      css={[
        styles.bggl,
        css`
          padding: 80px 0;
        `
      ]}
    >
      <Container>
        <div
          css={css`
            padding-bottom: 30px;
          `}
        >
          <h2>
            Looking for perks?
            <br />
            We've got you covered
          </h2>
        </div>
        <div css={[styles.flexWrap]}>
          <Benefit>
            <img src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/icon/salary.svg" />
            Competitive Salaries, Bonuses
          </Benefit>
          <Benefit>
            <img src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/icon/insurance.svg" />
            Health (in-patient & out-patient), Dental, and Vision insurance coverage
          </Benefit>
          <Benefit>
            <img src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/icon/learning.svg" />
            Learning & Development Stipend
          </Benefit>
          <Benefit>
            <img src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/icon/digital-currency.png" />
            Option of getting paid in digital currency
          </Benefit>
          <Benefit>
            <img src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/icon/holiday.svg" />
            Annual Outings
          </Benefit>
          <Benefit>
            <img src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/icon/casual-dress-code.svg" />
            Casual Dress Code
          </Benefit>
        </div>
      </Container>
    </div>
  );
}
